import { defineFieldDisplay } from "../defines";
import LabelsDisplay from "./labels-display.vue";

export default defineFieldDisplay({
  id: "labels",
  component: LabelsDisplay,
});
